var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('mq-layout',{attrs:{"mq":['sm', 'md']}},[_c('div',{staticClass:"mobile-index",attrs:{"id":"mobile-index"}},[_c('img',{attrs:{"src":require("@/assets/images/mobile/top.jpg"),"alt":""}})])])}
var staticRenderFns = []

export { render, staticRenderFns }